import { render, staticRenderFns } from "./InlineTextEditor.vue?vue&type=template&id=4b460d26&scoped=true&lang=html&"
import script from "./InlineTextEditor.vue?vue&type=script&lang=js&"
export * from "./InlineTextEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b460d26",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
